import { render } from "./review-module.vue?vue&type=template&id=698b7304&scoped=true"
import script from "./review-module.vue?vue&type=script&lang=js"
export * from "./review-module.vue?vue&type=script&lang=js"

import "./review-module.vue?vue&type=style&index=0&id=698b7304&scoped=true&lang=scss"
import "./review-module.vue?vue&type=style&index=1&id=698b7304&lang=css"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698b7304"]])

export default __exports__